import { render, staticRenderFns } from "./dictTypeList.vue?vue&type=template&id=1dae82f8&scoped=true&"
import script from "./dictTypeList.vue?vue&type=script&lang=js&"
export * from "./dictTypeList.vue?vue&type=script&lang=js&"
import style0 from "./dictTypeList.vue?vue&type=style&index=0&id=1dae82f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae82f8",
  null
  
)

export default component.exports